import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { Target } from "lucide-react";

// Shared palette constants — module-scoped so they don't re-allocate per render.
const COLOR_DONE = "#4A675C";
const COLOR_REMAINING = "#efe5d3";

/** Big mastery % donut + centered stat. */
export default function MasteryDonut({ pct, parts, isAr }) {
  return (
    <div className="rounded-2xl bg-white border border-border p-5 lg:col-span-4 flex flex-col" data-testid="mastery-donut-card">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-semibold mb-3">
        <Target className="w-3.5 h-3.5 text-sage" />
        {isAr ? "الإتقان العام" : "Overall mastery"}
      </div>
      <div className="relative flex-1 flex items-center justify-center min-h-[180px]">
        <ResponsiveContainer width="100%" height={200}>
          <PieChart>
            <Pie
              data={parts}
              dataKey="value"
              innerRadius={60}
              outerRadius={86}
              startAngle={90}
              endAngle={-270}
              stroke="none"
              paddingAngle={2}
            >
              <Cell fill={COLOR_DONE} />
              <Cell fill={COLOR_REMAINING} />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <div className="font-display text-3xl font-semibold tracking-tight text-sage">{pct}%</div>
          <div className="text-[10px] uppercase tracking-wider text-muted-foreground">
            {isAr ? "التقدم" : "progress"}
          </div>
        </div>
      </div>
      <div className="text-xs text-muted-foreground text-center mt-2">
        {isAr
          ? "50% من قراءة الفصل + 50% من أفضل درجات الاختبار"
          : "50% reading completion + 50% best quiz scores"}
      </div>
    </div>
  );
}
